import { render, staticRenderFns } from "./lan.vue?vue&type=template&id=3d896675&"
import script from "./lan.vue?vue&type=script&lang=js&"
export * from "./lan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports